export const allItaasBundles = ["None", "Standard", "Premium"];
export const allAsanaBundles = ["None", "Asana - Employee", "Asana - Owner"];
export const allCopilotBundles = ["None", "Copilot User License"];
export const allAdobeAcrobatProBundles = ["None", "Adobe Acrobat Pro"];
export const allTeamsPhoneBundles = ["None", "Teams Phone"];
export const allBundles = [
  "Accounting",
  "Operations",
  "Sales",
  "Executive",
  "Email Only",
  "Night Manager",
  "Administrative User",
  "CRM - Multi-Franchise",
];
